import React, {useState} from 'react'
import PlusIcon from "../../../../statics/assets/icons/plus.svg"
import ListContactFormModal from "./ListContactFormModal"

const ListContactForm = (props) => {
    const [showModal, toggleModal] = useState(false)

    const _toggleModal = () => {
        toggleModal(!showModal)
    }

    return <>
        <button className="ButtonCustom" onClick={_toggleModal}><PlusIcon width={12} height={12}/>Thêm mới</button>
        {showModal && <ListContactFormModal showModal={showModal} toggleModal={_toggleModal} {...props}/>}
    </>
}

export default ListContactForm
